import { useState, useEffect } from 'react';

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Check if user is authenticated by looking for a token in localStorage
    const token = localStorage.getItem('token');
    setIsAuthenticated(!!token);

    // Optional: You can also verify the token with your backend here
    // if (token) {
    //   verifyToken(token).then(isValid => setIsAuthenticated(isValid));
    // }
  }, []);

  return {
    isAuthenticated,
    setIsAuthenticated,
  };
}; 